module.exports = __webpack_public_path__ + "media/images/icons/icon_add_photo-baa28c8e7fcb857c3bb236f8de1041ac.svg";